// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8216b28","455":"80386f03","977":"bad71ff1"}[chunkId] + ".chunk.js";
};